import DivisionModel, { DivisionData, create as createDivision } from "../../models/DivisionModel";
import { Commit, Getter } from "vuex";
import Vue from 'vue';
import ApiService from "../../lib/api";

interface DivisionsState {
  divisions: Record<number, DivisionModel>;
  eventDivisions: Record<number, DivisionModel[]>;
  divisionIds: number[];
}

const state: DivisionsState = {
  divisions: {},
  eventDivisions: {},
  divisionIds: [],
};

interface Actions {
  getters: any;
  commit: Commit;
}

const mutations = {
  addDivision(store: DivisionsState, payload: { eventId: number, item: DivisionModel }): void {
    if (payload.item.data.id && store.divisionIds.indexOf(payload.item.data.id) === -1) {
      store.divisionIds.push(payload.item.data.id);

      Vue.set(store.divisions, payload.item.data.id, payload.item);
      // store.divisions[payload.item.data.id] = payload.item;
    }

    if (!store.eventDivisions[payload.eventId]) {
      Vue.set(store.eventDivisions, payload.eventId, []);
    }

    store.eventDivisions[payload.eventId].push(payload.item);
  }
};

const actions = {
  fetchEventDivisions({commit, getters}: Actions, eventId: number): Promise<any> {
    return new Promise(resolve => {
      if (getters.getEventDivisions(eventId).length > 0) {
        resolve();
        return;
      }
      ApiService.get(`/events/${eventId}/divisions`).then((resp: ApiResponseArray<DivisionData>) => {
        for (const i in resp.data) {
          commit('addDivision', {
            eventId,
            item: createDivision(resp.data[i])
          });
        }
      resolve();
      });
    });
  },
  addEventDivision({commit}: Actions, payload: {eventId: number, item: DivisionModel}): void {
    commit('addDivision', payload);
  }
};

const getters = {
  getEventDivisions: (state: DivisionsState) => (id: number): DivisionModel[] => {
    return state.eventDivisions[id] ?? [];
  },
  getById: (state: DivisionsState) => (id: number): DivisionModel | null => {
    return state.divisions[id] ?? null;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
